export { default as FeaturesClusterMarker } from './FeaturesClusterMarker';
